import mixins from 'synergycms_core/src/less/mixins';

export default {
  loadingContainer: {},
  loadingTable: {},
  loadingContent: {},
  loadingTitle: {},
  loaderSvg: {},
  loadingBackground: {},
  loadingTitle1: {},
  loadingTitle2: {},
  loadingAdvantage: {},
  advantageBreakfast: {},
  advantageCheck: {},
  advantageWater: {},
  starLogo: {},
  starTitle: {},
  starSubTitle: {},
  starLoadingMax: {},
  title: {
    color: data => data.mainColor,
    font: data => '300 24px ' + data.fontFamily1,
    display: 'block',
    textAlign: 'center',
    margin: '20px 0 8px'
  },
  descriptionText: {
    fontSize: '14px',
    '@media (min-width: 601px)': {
      fontSize: '16px'
    }
  },
  defaultStyle: {
    overflow: 'auto',
    font: data => '16px ' + data.fontFamily1,
    background: 'rgba(0, 0, 0, 0.5)',
    position: 'fixed',
    left: '0',
    top: '0',
    right: '0',
    bottom: '0',
    zIndex: '200'
  },
  loadingTable: {
    zIndex: '600!important',
  },
  loadingWrapper: {
    display: 'table',
    height: '100%',
    width: '100%',
    '& $loadingContainer': {
      display: 'table-cell',
      verticalAlign: 'middle',
      textAlign: 'center',
      padding: '20px',
      '& $loadingContent': {
        maxWidth: '400px',
        margin: '0 auto',
        '& $loadingTitle': {
          background: '#fff',
          padding: '18px 10px 20px',
          borderTop: data => '3px solid' + data.mainColor,
          '@media (min-width: 601px)': {
            padding: '40px 30px'
          }
        },
        '& $loadingBackground': {
          backgroundPosition: '-362px -41px',
          backgroundSize: '620px',
          backgroundRepeat: 'no-repeat',
          backgroundColor: data => data.mainColor,
          color: '#fff',
          padding: '35px 15px 15px',
          '& $starLogo': {
            display: 'none',
            '@media (min-width: 601px)': {
              display: 'block',
              marginBottom: '18px',
              '& svg': {
                fill: data => data.mainColor,
                width: '137px',
                height: '62px'
              }
            }
          },
          '& $loadingTitle1': {
            textTransform: 'uppercase',
            fontSize: '13px',
            letterSpacing: '0.5px',
            marginBottom: '7px',
            display: 'block'
          },
          '& $loadingTitle2': {
            font: data => '24px/1.25 ' + data.fontFamily2,
            marginBottom: '19px',
            display: 'block',
            '@media (min-width: 601px)': {
              marginBottom: 0
            }
          },
          '& $loadingAdvantage': {
            display: 'inline-block',
            listStyle: 'none',
            padding: '0',
            margin: '0',
            '& li': {
              textAlign: 'left',
              position: 'relative',
              padding: '5px 0 5px 50px',
              '&:before': {
                ...mixins.mixinBorderRadius('50%'),
                position: 'absolute',
                top: '0',
                left: '0',
                background: '#fff',
                font: '21px/42px Icons',
                color: data => data.mainColor,
                width: '42px',
                height: '42px',
                textAlign: 'center'
              },
              '&:not(:last-of-type)': {
                marginBottom: '13px'
              },
              '& > span': {
                display: 'block',
                lineHeight: '1.06',
                letterSpacing: '0.3px'
              }
            },
            '@media (min-width: 601px)': {
              margin: 0
            }
          },
          '& $advantageBreakfast': {
            '&:before': {
              content: "'e156'"
            }
          },
          '& $advantageCheck': {
            '&:before': {
              content: "'e155'"
            }
          },
          '& $advantageWater': {
            '&:before': {
              content: "'e157'"
            }
          },
          '@media (min-width: 601px)': {
            backgroundPosition: '62px -29px',
            backgroundSize: '473px',
            padding: '25px 30px 35px'
          },
          '& ul li': {
            '&:not(:last-of-type)': {
              '@media (min-width: 601px)': {
                margin: '19px 20px 0 0'
              },
              '&:lang(ar)':{
                '@media (min-width: 601px)': {
                  marginLeft:'20px',
                  marginRight:0
                }
              }
            },
            '@media (min-width: 601px)': {
              display: 'inline-block',
              verticalAlign: 'top',
              marginTop: '19px'
            }
          }
        },
        '& $loadingTitle2': {
          '@media (min-width: 601px)': {
            marginBottom: '24px'
          }
        },
        '@media (min-width: 601px)': {
          maxWidth: '600px'
        }
      },
      '@media (min-width: 601px)': {
        padding: '50px'
      }
    }
  },
  starLoadingContainer:{
    background: '#fff',
    padding: '20px',
    '& $starLoadingMax':{
      maxWidth: '430px',
      margin: '0 auto',
      '& $starLogo':{
        maxWidth: '220px',
        margin: '0 auto',
        fill: data => data.mainColor,
      },
      '& $starTitle':{
        display: 'block',
        font: data => '22px ' + data.fontFamily2,
        color: data => data.mainColor,
        marginTop: '20px',
        textTransform: 'uppercase',
      },
      '& $starSubTitle':{
        display: 'block',
        font: data => '16px ' + data.fontFamily1,
        maxWidth: '310px',
        margin: '10px auto 0',
      }
    }
  },
  '@keyframes rotateInfinite': {
    from: {transform: 'rotate(0deg)'},
    to: {transform: 'rotate(359deg)'}
  },
  loadingSvg: {
    fill:data=>data.mainColor,
    textAlign: 'center',
    display: 'block',
    margin: '0 auto',
    height: '56px',
    backgroundSize: 'contain',
    background: 'no-repeat center',
    animation: '$rotateInfinite 2s infinite linear',
    '& .cls-1':{opacity:0.2},
    '& .cls-2':{opacity:0.8},
    '& .cls-3':{opacity:0.1},
    '& .cls-4':{opacity:0.7},
    '& .cls-5':{opacity:0.05},
    '& .cls-6':{opacity:0.6},
    '& .cls-7':{opacity:0.03},
    '& .cls-8':{opacity:0.5},
    '& .cls-10':{opacity:0.4},
    '& .cls-11':{opacity:0.9},
    '& .cls-12':{opacity:0.3}
  }
};
